<h1>Settlements</h1>
<nav mat-tab-nav-bar [tabPanel]="tabPanel">
  @for (tab of tabs | visibleFinanceTabs; track tab) {
    <a mat-tab-link (click)="gotoTab(tab)" [active]="tab.link === activeTab.link">
      {{tab.title}}
    </a>
  }
</nav>

<div class="actionwrapper">
  <div class="actions">
    <button mat-raised-button color="primary" (click)="reloadItems()">Refresh</button>
    <button mat-raised-button color="primary" (click)="runSettlement()">
      <mat-icon>play_arrow</mat-icon>
      Run Settlement Workflow
    </button>
  </div>
</div>

<table class="table" mat-table matSort [dataSource]="items">
  <ng-container matColumnDef="id">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>ID</th>
    <td class="cell" mat-cell *matCellDef="let item">{{item.id}}</td>
  </ng-container>

  <ng-container matColumnDef="contractId">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Contract ID</th>
    <td class="cell" mat-cell *matCellDef="let item">{{item.contractId}}</td>
  </ng-container>

  <ng-container matColumnDef="periodStart">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Period Start</th>
    <td class="cell" mat-cell *matCellDef="let item">{{item.periodStart | date:'mediumDate'}}</td>
  </ng-container>

  <ng-container matColumnDef="periodEnd">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Period End</th>
    <td class="cell" mat-cell *matCellDef="let item">{{item.periodEnd | date:'mediumDate'}}</td>
  </ng-container>

  <ng-container matColumnDef="status">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
    <td class="cell" mat-cell *matCellDef="let item">{{item.status}}</td>
  </ng-container>

  <ng-container matColumnDef="totalPayable">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Total Payable</th>
    <td class="cell" mat-cell *matCellDef="let item">{{item.totalPayable}}</td>
  </ng-container>

  <ng-container matColumnDef="actionmenu" stickyEnd>
    <th mat-header-cell matTooltip="Actions" *matHeaderCellDef></th>
    <td mat-cell *matCellDef="let item">
      <button mat-button class="cell" [matMenuTriggerFor]="menu" [matMenuTriggerData]="{item: item}">
        <mat-icon matTooltip="Actions" class="more">more_vert</mat-icon>
      </button>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="allColumnNames"></tr>
  <tr class="listitem" mat-row *matRowDef="let rows; columns: allColumnNames"></tr>

  <mat-menu #menu="matMenu">
    <ng-template matMenuContent let-item="item">
      <button mat-menu-item (click)="viewSettlement(item)">View Details</button>
      <button mat-menu-item (click)="postSettlement(item)">Post Settlement</button>
      <button mat-menu-item (click)="markPaid(item)">Mark Paid</button>
      <button mat-menu-item (click)="issueInvoice(item)">Issue Invoice</button>
    </ng-template>
  </mat-menu>
</table>

@if (selectedSettlementJson) {
  <div class="json-view">
    <h3>Selected Settlement</h3>
    <pre>{{selectedSettlementJson}}</pre>
  </div>
}

<mat-tab-nav-panel #tabPanel></mat-tab-nav-panel>
